import { h, Component } from 'preact';

import style from './style.less';

import { configure } from '../../../config';
import TextCard from '../../cards/text-card';
import CardHeader from '../../pieces/card-header';
import { fetchArticleList } from '../../../lib/data';
import Customize, { customizeProps } from '../../pieces/customize';

import { TrackingProvider, trackEvent, DIMENSION, INPUT_KEYS, EVENT } from '@cube/track';

/**
 * The text cluster
 * Layout:
 * - 4-5 single line text only links
 * @param {Object} assets contents for the cards
*/
@configure([
	'singleCube.customizeCategories',
	'singleCube.browseCategories'
])
export default class TextCluster extends Component {

	state = {
		assets: []
	};

	getAssets = (props) => {
		fetchArticleList({
			count: props.cardCount,
			...props }
		)
			.then( res => {
				if (res.articles && res.articles.length > 0) {
					this.setState({ assets: res.articles });
				}
			});
	};

	onCustomize = ( newProps ) => {
		this.getAssets( { ...this.props, ...newProps } );
	};

	static defaultProps = {
		cardCount: 4
	};

	componentWillMount() {
		let props = customizeProps(this.props);
		this.getAssets(props);

		if (props.feed !== 'gen4_sc_suggested') {
			this.setState({ hideCustomizeLabel: true });
			trackEvent(this.context, {
				[INPUT_KEYS.action]: EVENT.impression,
				[DIMENSION.text]: props.feed
			});
		}
	}

	render(
		{ theme, title, link, qeId, cardCount, customizeKey, ...props },
		{ assets, hideCustomizeLabel }
	) {
		if (!assets || assets.length === 0) return null;

		return (
			<TrackingProvider {...{ [DIMENSION.componentpath]: 'TextCluster', [DIMENSION.title]: title }}>
				<div class={style.textCluster} qid={qeId}>
					<CardHeader title={title} link={link} qeId={qeId} theme={theme} customization={customizeKey && <Customize onCustomize={this.onCustomize} customizeKey={customizeKey} hideCustomizeLabel={hideCustomizeLabel} />} />
					<div class={style.cards}>
						{ assets.map((asset, i) => (
							<TrackingProvider {...{ [DIMENSION.clickindex]: i+1 }}>
								<TextCard
									theme={theme}
									asset={asset}
									qeId={qeId + '-' + i}
									{...props}
								/>
							</TrackingProvider>
						)) }
					</div>
				</div>
			</TrackingProvider>
		);
	}
}
